import i18next from 'i18next';

const newInstance = i18next.createInstance(
  {
    debug: process.env.NODE_ENV === 'development',
    ns: ['widget'],
    defaultNS: 'widget',
    fallbackLng: 'en',
    lowerCaseLng: true,
  },
  () => {},
);

const lang = window.mainConfig?.localeData?.loadedLanguage?.code || 'en';

async function loadLocale(languageCode) {
  try {
    const mod = await import(`../locale/${languageCode}.json`);
    const { default: locale } = mod;
    Object.keys(locale).forEach((ns) => {
      newInstance.addResourceBundle(languageCode, ns, locale[ns]);
    });
    newInstance.changeLanguage(languageCode);
  } catch (err) {
    loadLocale('en');
  }
}

loadLocale(lang);

export default newInstance;
